import React, {Component} from 'react'
import {ListGroup, ListGroupItem} from 'react-bootstrap'

class Blog extends Component {
  render() {
    return (
      <section id={this.props.id}>
        <div className='container'>
          <h2>Blog Posts</h2>
          <ListGroup>
            <ListGroupItem
              header='Edinburgh Alphabet Exhibition'
              href='https://medium.com/@josie_ide/edinburgh-alphabet-exhibition-so-now-im-an-exhibited-forensic-artist-79dc031e76e3'
              target='_blank'
            >so now I’m an exhibited Forensic Artist</ListGroupItem>
          </ListGroup>
        </div>
      </section>
    )
  }
}

export default Blog



// WEBPACK FOOTER //
// ./src/App/Blog/index.js